import React from "react";
import PropTypes from "prop-types";
import { Col } from "components/Containers";

/**
 * ApplicantLocation
 *
 * @param {String} country
 * @param {String} region
 * @param {String} continent
 */
const ApplicantLocation = ({ country, region, continent }) => (
  <Col gap="0.4rem">
    {country && <span>{country}</span>}
    {continent && <span>{continent}</span>}
    {region && <span>{region}</span>}
    {!region && !continent && !country && `Not specified`}
  </Col>
);

ApplicantLocation.propTypes = {
  country: PropTypes.string,
  region: PropTypes.string,
  continent: PropTypes.string,
};

export default ApplicantLocation;
